// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notes-area {
  border: 1px solid #EBE9EB;
  border-radius: 3px;
  background-color: #FCFCFC;
  width: 100%;
  height: 160px;
}

.bg-blue {
  background-color: #085FFF;
  color: white;
}

.lfp-button-container {
  margin-left: 0px !important;
  display: flex;
  width: 100%;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/app/components/interview-details/interview-create-league/interview-create-league.component.scss","webpack://./src/styles/global/_colors.scss"],"names":[],"mappings":"AACA;EACI,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;AAAJ;;AAEE;EACE,yBCJc;EDKd,YAAA;AACJ;;AACE;EACE,2BAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;AAEJ","sourcesContent":["@import '../../../../styles/global/colors';\n.notes-area {\n    border: 1px solid #EBE9EB;\n    border-radius: 3px;\n    background-color: #FCFCFC;\n    width: 100%;\n    height: 160px;\n  }\n  .bg-blue {\n    background-color: $interviews-blue;\n    color: white;\n  }\n  .lfp-button-container {\n    margin-left: 0px !important;\n    display: flex;\n    width: 100%;\n    justify-content: center;\n  }","$interviews-light-gray: #E0E0E0;\n$interviews-alt-light-gray: #ECECEC;\n$interviews-table-gray: #F5F5F5;\n$interviews-dark-gray: #262624;\n$interviews-gray: #585857;\n$interviews-blue: #085FFF;\n$interviews-scroll-blue: #b4ceff;\n$interviews-pink: #FF7FDE; \n$interviews-btn-submitted: #FADDB3;\n$interviews-btn-submitted-outline: #ED8E00;\n$interviews-btn-approved: #DAF2B7;\n$interviews-btn-approved-outline: #83D510;\n$interviews-btn-rejected: #FBCCD2;\n$interviews-btn-rejected-outline: #ED001C;\n$interviews-btn-draft: rgb(148, 148, 141);\n$interviews-btn-draft-outline: rgb(57, 57, 57);"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
